/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ChiaveMisura interface.
 */
export function instanceOfChiaveMisura(value) {
    return true;
}
export function ChiaveMisuraFromJSON(json) {
    return ChiaveMisuraFromJSONTyped(json, false);
}
export function ChiaveMisuraFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'nomeMisura': json['nomeMisura'] == null ? undefined : json['nomeMisura'],
    };
}
export function ChiaveMisuraToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'nomeMisura': value['nomeMisura'],
    };
}
